/**
 * This package's translations, registered at import.
 *
 * One namespace for both audiences — the applicant's form and the ADV's
 * review — because they are two views of one dossier and the vocabulary has to
 * match: what the form calls "pièces justificatives" is what the review screen
 * checks off, and two bundles would drift.
 */

import { registerNamespace } from "@hardauto/core-i18n";

import en from "./locales/en.json";
import fr from "./locales/fr.json";

export const NAMESPACE = "onboarding";

registerNamespace(NAMESPACE, { en, fr });
